import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
export function Hook() {
  return <Section background="white" data-id="element-136">
      <div className="prose prose-lg prose-stone mx-auto text-center md:text-left" data-id="element-137">
        <p className="text-xl md:text-2xl font-medium text-stone-900 leading-relaxed" data-id="element-138">
          El peor momento no es cuando estás "comiendo mal".
        </p>
        <p className="text-xl md:text-2xl font-bold text-stone-900 leading-relaxed" data-id="element-139">
          El peor momento es antes.
        </p>

        <div className="my-8 h-px w-24 bg-stone-200 mx-auto md:mx-0" data-id="element-140"></div>

        <p className="text-stone-600" data-id="element-141">
          Es ese segundo en el que abrís la heladera, estás cansada, y tu cabeza
          hace lo de siempre:
        </p>

        <blockquote className="text-2xl font-serif italic text-stone-800 border-l-4 border-emerald-500 pl-6 my-8 bg-stone-50 py-4 rounded-r-lg" data-id="element-142">
          "¿Qué como hoy… sin mandarme una?"
        </blockquote>

        <p className="text-stone-600" data-id="element-143">
          Y como no hay plan, terminás improvisando.
        </p>
        <p className="text-stone-600" data-id="element-144">
          Y la improvisación, con el tiempo, se vuelve una costumbre que te deja
          con la misma sensación:
        </p>

        <div className="bg-stone-900 text-white p-6 rounded-xl text-center font-bold text-xl my-8 shadow-lg transform -rotate-1" data-id="element-145">
          cansancio + culpa + ruido mental.
        </div>

        <p className="text-lg font-medium text-stone-900" data-id="element-146">
          Este PDF existe para una sola cosa:{' '}
          <span className="bg-amber-100 px-1" data-id="element-147">
            sacarte decisiones de encima.
          </span>
        </p>

        <div className="mt-10 text-center" data-id="element-148">
          <Button variant="outline" className="text-sm" data-id="element-149">
            Descargalo ahora — ARS 9.990
          </Button>
        </div>
      </div>
    </Section>;
}